import dayjs from "dayjs";

export const getRepliesLabel = (replyCount: number) => {
  return replyCount === 0 ? '' : replyCount === 1 ? '1 reply' : `${replyCount.toLocaleString()} replies`;
};

export const getDateString = (date: string) => {
  return dayjs(date).format('MMM D, YYYY');
};